// GENERATED FILE - DO NOT EDIT.
// Produced from the sibling .less file by packages/shared/theme/vars/lessToJs.js.
// Run `yarn workspace shared run gen:tokens` to regenerate.
module.exports = {
  "@blue-light": "#52aad5",
  "@yellow": "#f6b324",
  "@green": "#54cb76",
  "@green-dark": "#70c060",
  "@off-white": "#f0f2f5",
  "@blue": "#305366",
  "@primary-color": "#305366",
  "@pink": "#f294bb",
  "@secondary-color": "#f294bb",
  "@red": "#ec5863",
  "@danger": "#ec5863",
  "@divider-color": "#e8e8e8",
  "@text": "rgba(0, 0, 0, 0.65)",
  "@grey-light": "#fafafa",
  "@grey-medium": "#333333",
  "@grey-dark": "#323132",
  "@blue-1": "#305366",
  "@blue-2": "#3c7c9b",
  "@blue-3": "#52aad5",
  "@blue-4": "#81c1e0"
}
